import { FunctionalComponent, h } from "preact";
import Syles from "./styles.css";
interface IProps {
  handleExpandView: () => void;
  isPaying?: boolean;
}
const ExpandView: FunctionalComponent<IProps> = ({
  handleExpandView,
  isPaying,
}) => {
  const handleCloseWidget = () => {
    window.parent.postMessage("unloadCogWidget", "*");
    window.parent.postMessage(
      {
        type: "Korra_close", // Identifier for the action
        payload: { message: "Hello from iframe!" }, // Data to pass
      },
      "*" // Ensure this matches the parent origin
    );
  };
  return (
    <div className={Syles.widgetTopBar}>
      <div onClick={handleExpandView}>
        <img style={{ cursor: "pointer" }} src="/assets/widget/expand.svg" />
      </div>
      <div className={Syles.innerWrapper} onClick={() => handleCloseWidget()}>
        ✕
      </div>
    </div>
  );
};

export default ExpandView;
